var lookups = {}
var labels = {}
var appConfig = {}

var local = require('./store/local')

var filters = {
  label: function (key) {
    if (!labels[key]) {
      console.log('missing key: ' + key)
    }
    return labels[key] || key
  },
  lookup: function (key) {
    return lookups[key] || []
  },
  lookupValue: function (lookup, value) {
    return lookup.find(function (option) {
      return option.value === value
    }) || {}
  },
  appConfig: function (key) {
    return appConfig[key]
  },
  makeDate: function (dateString, timeZone, format) {
    if (!dateString) {
      return
    }
    var lang = local.get('client.language')
    // console.log(lang + ' as lang')
    if (!lang) {
      lang = 'en'
    }
    var moment = require('moment-timezone')
    var datetime = moment(dateString).locale(lang).tz(timeZone) // moment(dateString)locale('it').tz(timeZone)
    if (format) {
      return datetime.format(format)
    }
    return datetime
  },
  updateLabels: function (labs) {
    labels = labs
  }
}
module.exports = function (data) {
  if (data) {
    lookups = data.lookups
    labels = data.labels
    appConfig = data.appConfig
  }
  return filters
}



// WEBPACK FOOTER //
// ./src/common/filters.js